import { combineReducers } from "@reduxjs/toolkit"

import { callReducer, chatReducer, userReducer } from "./slices"

export const rootReducer = combineReducers({
    call: callReducer,
    chat: chatReducer,
    user: userReducer,
})
